export default {
  title: 'Solicitar fatura',
  form: {
    is_receipt_required: {
      label: 'Solicitar fatura por email',
    },
    company_name: {
      placeholder: 'Nome da empresa (opcional)',
    },
    first_name: {
      placeholder: 'Primeiro nome',
    },
    last_name: {
      placeholder: 'Apelido',
    },
    address: {
      placeholder: 'Rua + número',
    },
    zip_code: {
      placeholder: 'Código postal',
    },
    city: {
      placeholder: 'Cidade',
    },
    tax_id: {
      placeholder: 'NIF',
    },
    email: {
      placeholder: 'Endereço de email',
    },
  },
};
